import { getFriendlySampleSubtypeOrTypeLabel } from '@resistapp/client/utils/sample-subtype-filter-utils';
import { FullProject, FullSample, FullSamplesByUID } from '@resistapp/common/types';
import { values } from 'lodash';

export function buildSampleByIdMap(samplesByUID: FullSamplesByUID): Map<number, FullSample> {
  return new Map(
    values(samplesByUID)
      .flat()
      .map(sample => [sample.id, sample] as const),
  );
}

export function getProjectSampleById(project: FullProject | null): Map<number, FullSample> | null {
  if (!project) {
    return null;
  }

  return buildSampleByIdMap(project.samplesByUID);
}

export function getSampleSubtypeOrTypeLabel(
  sample: Pick<FullSample, 'samplingPoint'> | undefined | null,
): string | null {
  if (!sample) {
    return null;
  }

  return getFriendlySampleSubtypeOrTypeLabel(sample.samplingPoint.type, sample.samplingPoint.subtype);
}
